// @flow
import React from 'react';
import { MdDirections } from 'react-icons/lib/md';

import OmnisearchResultDummy from '../OmnisearchResultDummy';


type RouteStopResultPropTypes = {
  name?: string,
  routeName?: string,
  address?: string,
  isSelected?: boolean,
  size?: string,
  onClick?: Function
};

const RouteStopResult = ({
  name = '',
  routeName = '',
  // address = '',
  isSelected = false,
  size = 'medium',
  onClick,
}: RouteStopResultPropTypes) => (
  <OmnisearchResultDummy
    title={name}
    subtitle={routeName}
    Icon={MdDirections}
    isSelected={isSelected}
    size={size}
    onClick={onClick}
  />
);

export default RouteStopResult;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteStopResult/index.jsx